import {
  ADD_TAG,
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SHOW_MESSAGE, STOP_TAG_LOADER, UPDATE_TAG,
} from "../constants/ActionTypes";

export const fetchStart = () => {
  return {
    type: FETCH_START
  }
};

export const fetchSuccess = () => {
  return {
    type: FETCH_SUCCESS
  }
};

export const fetchError = (error) => {
  return {
    type: FETCH_ERROR,
    payload: error
  }
};

export const showMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  }
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE
  }
};


/* ****************
Adding a Tag
 *******************/

// jfd********** `--===<>==<>==C>-<
/**
 * Summary. addTag
 *
 * Description. Don't use this function directly. Use a helper function.
 *
 * @param {function}    successAction   used by Saga to route a successful API request to the correct reducer.
 * @param {function}    failAction      used by Saga to route a failed API request to the correct reducer
 * @param {string}    entityId          Id of the entity (required)
 * @param {string}    definitionId      Id of the tag definition (required)
 * @param {string}    targetId          Id of the target (optional)
 * @param {string}    vectorId          Id of the vector (optional)
 * @param {string}    testedVectorId    Id of the tested vector (optional)
 * @param {string}    identityId        Id of the identity (optional)
 * @param {string}    details           Text containing details (optional)
 * @param {string}    userId            Id of the user (optional)
 * @param {number}    customerId        Id of the customer (optional)
 * @param {boolean}    showUserMessage   Whether to show user messages (default is true)
 * @param {string}    affectedElementId ID used to track loaders. Since there are multiple ids possible. Defaults to first found from among the above.
 *
 * @yield {type} Yielded value description.
 *
 * @return {type} Return value description.
 */
    //*****************************************
    //const addTag = (customerId, entityId, affectedElementId, definitionId, testedVectorId, details = null, showUserMessage=true) => {
export const addTag = (
        successAction = () => null,
        failAction = () => null,
        definitionId,
        entityId= null,
        targetId = null,
        vectorId = null,
        testedVectorId = null,
        identityId = null,
        details = null,
        userId  = null,
        customerId = null,
        subportfolioId = null,
        showUserMessage= true,
        affectedElementId = //to give the loader a unique ID to track. Check each Id until find one.
            testedVectorId
                ? testedVectorId
                : targetId
                    ? targetId
                    : vectorId
                        ? vectorId
                        : identityId
                            ? identityId
                            : userId
                                ? userId
                                : customerId
                                    ? customerId
                                : entityId
                                    ? entityId
                                    : null,
    ) => {
      const payload = {
        successAction,
        failAction,
        entityId,
        definitionId,
        targetId,
        vectorId,
        testedVectorId,
        identityId,
        details,
        userId,
        customerId,
        subportfolioId,
        showUserMessage,
        affectedElementId
      }

      console.log("About to add a tag with this payload", payload);

      return {
        type: ADD_TAG,
        payload
      };
    };


/*  jfd**********22.Jan.24.11:23*****
 *   These add Tag success and failure functions going to be commented out
 *  so we don't use them because each type/group of tags will need to
 * consider specific parts of the state.
     ********************** `--===<>==<>==C>-< */
// export const addTagSuccess = (data) => {
//     return {
//         type: ADD_TAG_SUCCESS,
//         payload: data
//     };
// };
//
// export const addTagFail = (data) => {
//     return {
//         type: ADD_TAG_FAIL,
//         payload: data
//     };
// };
//END OF addTAG ARCHIVE


/* ****************
Updating a Tag
 *******************/
export const updateTag = (successAction = () => null,
                          failAction = () => null, tagId, newIsActive, customerId = null, affectedElementId = null, ) => {
  const payload = {
    successAction,
    failAction,
    tagId,
    newIsActive,
    customerId,
    // showUserMessage,
    affectedElementId,
  }

  console.log("About to update a tag with this payload", payload);

  return {
    type: UPDATE_TAG,
    payload
  };
};

export const stopTagLoader = (id, didFail) => {
  const payload = {
    id,
    didFail,
  }

  console.log("Stopping tag loader with this payload", payload);

  return {
    type: STOP_TAG_LOADER,
    payload
  };
}







